const r = {
  "cdr-image": "cdr-image_13-5-2",
  "cdr-image--responsive": "cdr-image--responsive_13-5-2",
  "cdr-image--rounded": "cdr-image--rounded_13-5-2",
  "cdr-image--circle": "cdr-image--circle_13-5-2",
  "cdr-image-ratio": "cdr-image-ratio_13-5-2",
  "cdr-image-ratio__cover": "cdr-image-ratio__cover_13-5-2",
  "cdr-image-ratio__cover--crop": "cdr-image-ratio__cover--crop_13-5-2",
  "cdr-image-ratio__cover--cover": "cdr-image-ratio__cover--cover_13-5-2"
};
export {
  r as default
};
